// @flow
export const TOGGLER_THEME_API = {
  root: '',
  input: '',
  toggler: '',
  label: '',
  disabled: '',
  checked: ''
};
